import React, { useMemo, useEffect, useState } from "react"
import {
  Container,
  CardBody,
  Card,
  UncontrolledPopover,
  PopoverBody,
} from "reactstrap"
import Breadcrumb from "components/Common/Breadcrumb"
import { Link, useLocation, useNavigate } from "react-router-dom"
import { app_url, fixedIds } from "app_config"
import moment from "moment"
import AddHoursTime from "pages/Timesheet/AddHoursTime"
import TimeHistory from "pages/Timesheet/TimeHistory"
import { axiosbaseurl } from "configure"
import Loader from "components/Common/Loader"
import { usePermissionData } from "AppContext"
import PermittedComponent from "components/Common/PermittedComponent"
import TimesheetFilter from "components/Common/TimesheetFilter"
import secureLocalStorage from "react-secure-storage"
import { useDispatch, useSelector } from "react-redux"
import { startTimer } from "store/timer/actions"
import CommonTable from "components/Common/CommonTable"
import swal from "sweetalert"
import ClientEmailsModal from "./ClientEmailsModal"
import { designation_options } from "constants/layout"

const AllTasks = () => {
  const [table_data, settable_data] = useState([])
  const [all_tasks, setAllTasks] = useState([])
  const [all_services, setAllServices] = useState([])
  const [all_tags, setAllTags] = useState([])
  const [status_options, setstatus_options] = useState([])
  const [taskName_options, settaskName_options] = useState([])
  const [clientName_options, setclientName_options] = useState([])
  const [clientCode_options, setclientCode_options] = useState([])
  const [allowed_status_options, setallowed_status_options] = useState([])
  const [emp_options, setemp_options] = useState([])
  const [designations, setdesignations] = useState([])
  const [isArchivedAllowed, setIsArchivedAllowed] = useState(false)
  const [selectForAction, setSelectForAction] = useState([])
  const [selectedStatus, setSelectedStatus] = useState("")
  const [taskEmailCounts, setTaskEmailCounts] = useState({})

  const timerState = useSelector(state => state.timer)

  const [loading, setLoading] = useState(false)

  const dispatch = useDispatch()
  const locationData = useLocation()

  const getAllTags = async () => {
    try {
      const reponse = await axiosbaseurl.get("/service/tags")
      if (reponse.data.success) {
        setAllTags(reponse.data.data)
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    const getTasksWithoutLoader = async () => {
      try {
        const response = await axiosbaseurl.get("/tasks")
        if (response.data.success) {
          const tempTasks = response.data.data
            ?.filter(
              t =>
                t.client &&
                t.serviceName?.serviceCategory !==
                  "Non-Billiable and Non-scheduled"
            )
            //  && t.serviceName?.serviceCategory !== "Non-Billiable and Non-scheduled"
            .map(item => {
              const primary = {
                Administrator: `${item.administrator?.name || " "}  ${
                  item.administrator?.lastName || " "
                }`,
                Assistant: `${item.assistant?.name || " "}  ${
                  item.assistant?.lastName || " "
                }`,
                "Client Manager": `${item.clientManager?.name || " "}  ${
                  item.clientManager?.lastName || " "
                }`,
                "Production Manager": `${
                  item.productionManager?.name || " "
                }  ${item.productionManager?.lastName || " "}`,
              }

              const isPrimaryAvailable = JSON.parse(
                item?.serviceName?.autoTasks || "[]"
              )?.find(i => i.task_name === item.title)?.primaryDesignation

              return {
                ...item,
                clientName: item?.client?.clientName,
                clientCode: item?.client?.clientCode,
                taskName: item?.title,
                service_name: item?.serviceName?.serviceName,
                statusName: item?.status?.statusName,
                periodEnd: item?.startDate,
                timer: item.timer || false,
                clientCode: item?.client?.clientCode,
                assistantName: `${item?.assistant?.name || "-"} ${
                  item?.assistant?.lastName || "-"
                }`,
                primaryPerson:
                  item.isAutoCreated && isPrimaryAvailable
                    ? primary[isPrimaryAvailable]
                    : "--",
              }
            })

          if (locationData.state?.data)
            settable_data(
              onMoveToTop(
                tempTasks.filter(
                  task => task?.status?.id == locationData.state?.data
                )
              )
            )
          else settable_data(onMoveToTop(tempTasks))

          setAllTasks(tempTasks)

          // creating employees options
          setEmployeesOptions(response.data.data)

          if (response.data.isAdmin) {
            setdesignations(designation_options.map(des => des.value))
            setIsArchivedAllowed(true)
          } else if (response.data.employeeDesignation) {
            setdesignations(JSON.parse(response.data.employeeDesignation))
            if (fixedIds.archivedRoleId == response.data.roleId) {
              setIsArchivedAllowed(true)
            }
          }
        }
      } catch (error) {
        console.log(error)
      }
    }
    getTasksWithoutLoader()
    getAllTags()
  }, [timerState.timer])

  useEffect(() => {
    const getTasks = async () => {
      try {
        setLoading(true)
        const [response, response2] = await Promise.all([
          axiosbaseurl.get("/tasks"),
          axiosbaseurl.get("/client-email"),
        ])
        if (response.data.success) {
          const tempTasks = response.data.data
            ?.filter(
              t =>
                t.client &&
                t.serviceName?.serviceCategory !==
                  "Non-Billiable and Non-scheduled"
            )
            //  && t.serviceName?.serviceCategory !== "Non-Billiable and Non-scheduled"
            .map(item => {
              const primary = {
                Administrator: `${item.administrator?.name || " "} ${
                  item.administrator?.lastName || " "
                }`,
                Assistant: `${item.assistant?.name || " "}  ${
                  item.assistant?.lastName || " "
                }`,
                "Client Manager": `${item.clientManager?.name || " "}  ${
                  item.clientManager?.lastName || " "
                }`,
                "Production Manager": `${
                  item.productionManager?.name || " "
                }  ${item.productionManager?.lastName || " "}`,
              }

              const isPrimaryAvailable = JSON.parse(
                item?.serviceName?.autoTasks
              )?.find(i => i.task_name === item.title)?.primaryDesignation

              return {
                ...item,
                clientName: item?.client?.clientName,
                service_name: item?.serviceName?.serviceName,
                clientCode: item?.client?.clientCode,
                taskName: item?.title,
                statusName: item?.status?.statusName,
                periodEnd: item?.startDate,
                timer: item.timer || false,
                isDelayed: moment(item.dueDate).isBefore(),
                clientCode: item?.client?.clientCode,
                assistantName: `${item?.assistant?.name || "-"} ${
                  item?.assistant?.lastName || "-"
                }`,
                primaryPerson:
                  item.isAutoCreated && isPrimaryAvailable
                    ? primary[isPrimaryAvailable]
                    : "--",
              }
            })

          if (locationData.state?.data)
            settable_data(
              onMoveToTop(
                tempTasks.filter(
                  task => task?.status?.id == locationData.state?.data
                )
              )
            )
          else settable_data(onMoveToTop(tempTasks))

          setAllTasks(tempTasks)

          // creating employees options
          setEmployeesOptions(response.data.data)

          // making service options
          const services = tempTasks?.map(t => t.serviceName)
          const uniqueServices = services
            ?.filter(s => s?.id != null)
            .filter(
              (service, index, self) =>
                index === self?.findIndex(s => s.id === service.id)
            )
          setAllServices(uniqueServices)

          // making status options
          const status = tempTasks?.map(t => t.status)
          const uniqueStatus = status
            ?.filter(s => s?.id != null)
            .filter(
              (sts, index, self) =>
                index === self?.findIndex(s => s?.id === sts?.id)
            )
          setstatus_options(uniqueStatus)

          const taskName = tempTasks?.map(t => t.taskName)
          const uniqueTaskName = [...new Set(taskName)]
          settaskName_options(uniqueTaskName)

          const clientName = tempTasks?.map(t => t.clientName)
          const uniqueClientName = [...new Set(clientName)]
          setclientName_options(uniqueClientName)

          const clientCode = tempTasks?.map(t => t.clientCode)
          const uniqueClientCode = [...new Set(clientCode)]
          setclientCode_options(uniqueClientCode)

          if (response.data.isAdmin) {
            setdesignations(designation_options.map(des => des.value))
            setIsArchivedAllowed(true)
          } else if (response.data.employeeDesignation) {
            setdesignations(JSON.parse(response.data.employeeDesignation))
            if (fixedIds.archivedRoleId == response.data.roleId) {
              setIsArchivedAllowed(true)
            }
          }
        }
        if (response2?.data?.success) {
          const emails = response2.data.data || []
          const counts = {}
          emails.forEach(email => {
            if (email.taskId)
              counts[email.taskId] = (counts[email.taskId] || 0) + 1
          })
          setTaskEmailCounts(counts)
        }
      } catch (error) {
        console.log(error)
      } finally {
        setLoading(false)
      }
    }

    getTasks()
    getAllTags()
  }, [])

  // creating data for filter
  // useEffect(() => {
  //   if (table_data) {

  //     // making service options
  //     const services = table_data?.map(t => t.serviceName)
  //     const uniqueServices = services?.filter(
  //       (service, index, self) =>
  //         index === self?.findIndex(s => s.id === service.id)
  //     )
  //     setAllServices(uniqueServices)

  //     // making status options
  //     const status = table_data?.map(t => t.status)
  //     const uniqueStatus = status?.filter(
  //       (sts, index, self) =>
  //         index === self?.findIndex(s => s.id === sts.id)
  //     )
  //     setstatus_options(uniqueStatus)

  //     const taskName = table_data?.map(t => t.taskName)
  //     settaskName_options(taskName)

  //     const clientName = table_data?.map(t => t.clientName)
  //     const uniqueClientName = [
  //       ...new Set(clientName?.map(c => c.clientName)),
  //     ]
  //     setclientName_options(uniqueClientName)

  //     const clientCode = table_data?.map(t => t.clientCode)
  //     const uniqueClientCode = [
  //       ...new Set(clientCode?.map(c => c.clientCode)),
  //     ]
  //     setclientCode_options(uniqueClientCode)
  //   }
  // }, [table_data])

  useEffect(() => {
    const getAllActiveStatus = async () => {
      try {
        const response = await axiosbaseurl(`/status-master/active`)
        if (response.data.success) {
          setallowed_status_options(response.data.data)
        }
      } catch (error) {
        console.log(error)
      }
    }

    getAllActiveStatus()
  }, [])

  function setEmployeesOptions(employees = []) {
    const emps = []
    const assistants = [
      "assistant",
      "assistantTwo",
      "assistantThree",
      "assistantFour",
    ]
    const empTypes = [
      ...assistants,
      "clientManager",
      "productionManager",
      "administrator",
    ]

    employees.forEach(curr => {
      assistants.forEach(empType => {
        if (!emps.some(i => i?.id === curr[empType]?.id) && curr[empType])
          emps.push({ ...curr[empType], isAssistant: true })
      })
    })

    employees.forEach(curr => {
      empTypes.forEach(empType => {
        if (!emps.some(i => i?.id === curr[empType]?.id) && curr[empType])
          emps.push(curr[empType])
      })
    })
    setemp_options(emps)
  }

  const handleAllCheckUncheck = e => {
    if (e.target.checked) {
      if (table_data.length < 10) {
        setSelectForAction(table_data.map(task => task.id))
      } else
        swal("Limit Reached!", "You can select maximum 10 items.", "warning")
    } else {
      setSelectForAction([])
    }
  }

  const handleUpdateStatus = async () => {
    if (selectForAction.length === 0) {
      swal({
        title: "No Tasks Selected",
        text: "Please select at least one task to update the status.",
        icon: "warning",
      })
      return
    }

    if (!selectedStatus) {
      swal({
        title: "No Status Selected",
        text: "Please select a status to apply.",
        icon: "warning",
      })
      return
    }

    const selectedStatusObj = allowed_status_options.find(
      s => s.id === Number(selectedStatus)
    )

    const willUpdate = await swal({
      title: "Are you sure?",
      text: `You are about to update the status of task to "${selectedStatusObj?.statusName}".`,
      icon: "warning",
      buttons: ["Cancel", "Yes, Update"],
      dangerMode: true,
    })

    if (!willUpdate) {
      setSelectForAction([])
      setSelectedStatus("")
      return
    }

    try {
      setLoading(true)
      const response = await axiosbaseurl.put("/tasks/update/mutilple/status", {
        ids: selectForAction,
        statusId: selectedStatus,
        time: moment().format("HH:mm"),
      })

      if (response.data.success) {
        const updatedData = all_tasks.map(task =>
          selectForAction.includes(task.id)
            ? {
                ...task,
                statusId: Number(selectedStatus),
                status: {
                  ...task.status,
                  id: Number(selectedStatus),
                  statusName: selectedStatusObj.statusName,
                },
                statusName: selectedStatusObj.statusName,
              }
            : task
        )

        const filteredData = updatedData.filter(
          task => task.statusId !== fixedIds.HMRCStatus
        )

        settable_data(onMoveToTop(filteredData))
        setAllTasks(filteredData)
        setSelectForAction([])
        setSelectedStatus("")

        swal({
          text: "Status updated successfully",
          icon: "success",
        })
      }
    } catch (error) {
      console.error("Status update failed:", error)
      swal({
        title: "Error",
        text: error?.response?.data?.message || "Failed to update task status.",
        icon: "error",
      })
    } finally {
      setLoading(false)
    }
  }

  document.title = "Task Management | Peacock Accountants Limited"

  async function startTimerFunction(task_id) {
    try {
      const response = await axiosbaseurl.post("/task-updates/start/timer", {
        taskId: task_id,
        startTime: moment().format("HH:mm"),
      })

      if (response.data.success) {
        const updatedData = all_tasks.map(task =>
          task.id === task_id
            ? {
                ...task,
                timer: true,
                logId: response.data.data.id,
                client: { ...task.client },
                serviceName: { ...task.serviceName },
                status: { ...task.status },
              }
            : task
        )

        const movedToTop = onMoveToTop(updatedData)

        settable_data(movedToTop)
        setAllTasks(updatedData)

        dispatch(startTimer())
      }
    } catch (error) {
      console.error("Start timer failed:", error)
      swal(
        "",
        error?.response?.data?.message || "Something went Wrong",
        "error"
      ).then(() => {
        if (
          error?.response?.data?.message ===
          "Task have been moved to archived !"
        ) {
          window.location.reload()
        }
      })
    }
  }

  function onMoveToTop(tasks) {
    const index = tasks.findIndex(task => task.timer)
    if (index === -1) return [...tasks]

    const timerTask = tasks[index]
    const otherTasks = [...tasks.slice(0, index), ...tasks.slice(index + 1)]
    return [...otherTasks, timerTask]
  }

  return (
    <>
      {loading && <Loader />}
      <div className="page-content mb-5">
        <Container fluid>
          <Breadcrumb title={"Dashboard"} breadcrumbItem={"Tasks"} />

          <Card className="px-0 mx-0">
            <CardBody>
              <TableComponent
                table_data={table_data}
                settable_data={settable_data}
                all_tasks={all_tasks}
                all_tags={all_tags}
                all_services={all_services}
                status_options={status_options}
                taskName_options={taskName_options}
                clientName_options={clientName_options}
                clientCode_options={clientCode_options}
                startTimer={startTimerFunction}
                emp_options={emp_options}
                allowed_status_options={allowed_status_options}
                designations={designations}
                isArchivedAllowed={isArchivedAllowed}
                selectForAction={selectForAction}
                setSelectForAction={setSelectForAction}
                handleAllCheckUncheck={handleAllCheckUncheck}
                selectedStatus={selectedStatus}
                setSelectedStatus={setSelectedStatus}
                handleUpdateStatus={handleUpdateStatus}
                setAllTasks={setAllTasks}
                taskEmailCounts={taskEmailCounts}
              />
            </CardBody>
          </Card>
        </Container>
      </div>
    </>
  )
}

const TableComponent = ({
  table_data,
  settable_data,
  all_tasks,
  all_tags,
  setAllTasks,
  all_services,
  status_options,
  allowed_status_options,
  startTimer,
  emp_options,
  taskName_options,
  clientName_options,
  clientCode_options,
  designations,
  isArchivedAllowed,
  selectForAction,
  setSelectForAction,
  handleAllCheckUncheck,
  selectedStatus,
  setSelectedStatus,
  handleUpdateStatus,
  taskEmailCounts,
}) => {
  const navigate = useNavigate()

  const [show, setShow] = useState(false)
  const [showHistory, setShowHistory] = useState(false)
  const [ids, setIds] = useState(null)
  const [taskData, setTaskData] = useState(null)

  const [showEmails, setShowEmails] = useState(false)
  const [showEmailFiles, setShowEmailFiles] = useState(false)
  const [emailFilesClient, setEmailFilesClient] = useState({})

  const { checkAccess, permissions } = usePermissionData()
  const module_id = 2

  // columns
  const columns = useMemo(
    () => [
      {
        Header: "",
        accessor: "checkbox",
        disableSort: true,
        disableFilters: true,
        Cell: cellProps => (
          <input
            type="checkbox"
            onChange={e => {
              if (e.target.checked) {
                if (selectForAction.length < 10) {
                  setSelectForAction(prev => [
                    ...prev,
                    cellProps.row.original.id,
                  ])
                } else
                  swal(
                    "Limit Reached!",
                    "You can select maximum 10 items.",
                    "warning"
                  )
              } else {
                setSelectForAction(prev =>
                  prev.filter(s => s !== cellProps.row.original.id)
                )
              }
            }}
            checked={selectForAction.some(s => s === cellProps.row.original.id)}
          />
        ),
      },
      {
        Header: "ID",
        accessor: "id",
        filterable: true,
        disableFilters: true,
        className: " text-center",
        Cell: cellProps => <span>{cellProps.row.index + 1}</span>,
      },
      {
        Header: "Client Code",
        accessor: "clientCode",
        disableFilters: true,
        filterable: true,
        Cell: cellProps => (
          <Link
            to={`${app_url}edit-client/${cellProps.row.original.clientId}`}
            style={{ color: "#40a676" }}
            className="fw-bold"
          >
            {cellProps.row.original.clientCode}
          </Link>
        ),
      },
      {
        Header: "Client Name",
        accessor: "clientName",
        disableFilters: true,
        filterable: true,
        Cell: cellProps => (
          <div
            className={`fw-bold ${
              cellProps.row.original.isDelayed && "text-danger"
            }`}
          >
            {cellProps.row.original.clientName}
          </div>
        ),
      },
      {
        Header: "Task Name",
        accessor: "title",
        disableFilters: true,
        filterable: true,
        Cell: cellProps => (
          <div
            className={`${cellProps.row.original.isDelayed && "text-danger"}`}
          >
            {cellProps.row.original.title}
          </div>
        ),
      },
      {
        Header: "Period End",
        accessor: "startDate",
        disableFilters: true,
        filterable: true,
        Cell: cellProps => (
          <span
            className={`${cellProps.row.original.isDelayed && "text-danger"}`}
          >
            {moment.utc(cellProps.row.original.startDate).format("DD/MM/YY")}
          </span>
        ),
      },
      {
        Header: "Due Date",
        accessor: "dueDate",
        disableFilters: true,
        filterable: true,
        Cell: cellProps => (
          <span
            className={`${cellProps.row.original.isDelayed && "text-danger"}`}
          >
            {moment.utc(cellProps.row.original.dueDate).format("DD/MM/YY")}
          </span>
        ),
      },
      {
        Header: "Assistant",
        accessor: "assistantName",
        disableFilters: true,
        filterable: true,
      },
      {
        Header: "Primary Designation",
        accessor: "primaryPerson",
        disableFilters: true,
        filterable: true,
      },
      {
        Header: "Service",
        accessor: "service_name",
        disableFilters: true,
        filterable: true,
        className: "d-none",
      },
      {
        Header: "Status",
        disableSort: true,
        accessor: "statusName",
        disableFilters: true,
        filterable: true,
        className: "text-center",
        Cell: cellProps => {
          const status = cellProps.row.original?.status
          const colorCode = status?.colorCode || "#dc3545"
          const statusName = status?.statusName || "Error Status"
          return (
            <div className="text-center">
              <span
                className="badge text-wrap lh-sm"
                style={{
                  color: colorCode,
                  border: `1px solid ${colorCode}`,
                  fontSize: "11px",
                }}
              >
                {statusName}
              </span>
            </div>
          )
        },
      },
      {
        Header: "Time Spent",
        accessor: "totalTimeSpent",
        disableFilters: true,
        filterable: true,
        Cell: cellProps => (
          <span>{`${cellProps.row.original.totalTimeSpent} hrs`}</span>
        ),
      },
      {
        Header: "Emails",
        accessor: "emailCount",
        disableFilters: true,
        className: "text-center",
        Cell: cellProps => {
          const count = taskEmailCounts[cellProps.row.original.id] || 0
          return (
            <span
              className={`badge ${count ? "bg-primary" : "bg-secondary"}`}
              style={{ fontSize: "0.8rem" }}
            >
              {count}
            </span>
          )
        },
      },
      {
        Header: "Action",
        disableFilters: true,
        disableSort: true,
        accessor: "view",
        className: `text-center ${checkAccess(24, "add") && "col-2"}`,
        Cell: cellProps => {
          const {
            id,
            timer,
            clientId,
            title,
            client,
            logId,
            createdBy,
            createdAt,
            labels,
            isAutoCreated,
            serviceNameId,
          } = cellProps.row.original

          // Unique popover ID for this row (very important!)
          const labelsPopoverId = `labels-popover-${id}`
          const createdByPopoverId = `createdby-popover-${id}` // different ID to avoid conflict
          const autoCreatedPopoverId = `autoCreated-popover-${id}` // different ID to avoid conflict

          return (
            <div className="d-flex justify-content-end">
              {labels && JSON.parse(labels).length > 0 && (
                <>
                  <button
                    id={labelsPopoverId}
                    type="button"
                    className="btn btn-info btn-sm me-2"
                    title="Tags"
                  >
                    <i className="fas fa-tags"></i>
                  </button>

                  <UncontrolledPopover
                    placement="top"
                    target={labelsPopoverId}
                    trigger="hover"
                    fade={false}
                    popperClassName="shadow-lg"
                  >
                    <PopoverBody className="p-2">
                      <div className="d-flex flex-wrap gap-2">
                        {JSON.parse(labels).map((label, idx) => (
                          <span
                            key={idx}
                            className="badge bg-info text-white px-2 py-1"
                            style={{ fontSize: "0.75rem" }}
                          >
                            {label}
                          </span>
                        ))}
                      </div>
                    </PopoverBody>
                  </UncontrolledPopover>
                </>
              )}

              {createdBy && createdBy.name && (
                <>
                  <button
                    id={createdByPopoverId}
                    type="button"
                    className="btn btn-warning btn-sm me-2"
                    title="Created By"
                  >
                    <i className="fas fa-user"></i>
                  </button>

                  <UncontrolledPopover
                    placement="top"
                    target={createdByPopoverId}
                    trigger="hover"
                    fade={false}
                  >
                    <PopoverBody className="p-2">
                      <div>
                        <strong className="text-primary">Created By</strong>
                        <br />
                        <strong>
                          {createdBy.name} {createdBy.lastName || ""}
                        </strong>
                        <br />
                        <small className="fw-semibold">
                          {createdAt
                            ? moment(createdAt).format("DD MMM YYYY • HH:mm A")
                            : "—"}
                        </small>
                      </div>
                    </PopoverBody>
                  </UncontrolledPopover>
                </>
              )}

              {isAutoCreated && (
                <>
                  <button
                    id={autoCreatedPopoverId}
                    type="button"
                    className="btn btn-light btn-sm me-2"
                    title="Auto Created"
                  >
                    <i className="mdi mdi-android-auto fs-6"></i>
                  </button>

                  <UncontrolledPopover
                    placement="top"
                    target={autoCreatedPopoverId}
                    trigger="hover"
                    fade={false}
                  >
                    <PopoverBody className="p-2">
                      <div>
                        <strong className="text-primary fw-semibold">
                          Auto Generated Task
                        </strong>
                        <br />
                        <small className="fw-semibold">
                          {createdAt
                            ? moment(createdAt).format("DD MMM YYYY • HH:mm A")
                            : "—"}
                        </small>
                      </div>
                    </PopoverBody>
                  </UncontrolledPopover>
                </>
              )}

              {checkAccess(module_id, "edit") && (
                <Link
                  to={`${app_url}edit-task/${id}`}
                  className="btn btn-success bg-green btn-sm me-2"
                >
                  <i className="fas fa-pen"></i>
                </Link>
              )}

              {checkAccess(24, "add") && (
                <>
                  <button
                    onClick={() => {
                      if (timer) {
                        setIds({
                          task: id,
                          client: clientId,
                          service: serviceNameId,
                          taskName: title,
                          clientName: client.clientName,
                          logId: logId,
                          stopingTimer: true,
                        })
                        setShow(true)
                      } else {
                        startTimer(id)
                      }
                    }}
                    title="Work Report Timer"
                    className={`btn btn-${
                      timer ? "danger" : "primary"
                    } btn-sm me-2`}
                  >
                    <i className="fas fa-clock"></i>
                  </button>
                  <button
                    onClick={() => {
                      setShowHistory(true)
                      setTaskData({
                        task: id,
                        client: clientId,
                        service: serviceNameId,
                        taskName: title,
                        clientName: client.clientName,
                      })
                    }}
                    title="View Work History"
                    className="btn btn-dark btn-sm me-2"
                  >
                    <i className="dripicons-blog"></i>
                  </button>
                </>
              )}
              <button
                onClick={() => {
                  setEmailFilesClient(cellProps.row.original)
                  setShowEmailFiles(true)
                }}
                title="Email Files (.msg / .eml)"
                className="btn btn-info btn-sm me-2"
              >
                <i className="fas fa-paperclip"></i>
              </button>
            </div>
          )
        },
      },
    ],
    [permissions, table_data, selectForAction, taskEmailCounts]
  )

  // table data
  const data = useMemo(() => table_data, [table_data])

  const { employeeId } = secureLocalStorage.getItem("authUser")

  const allowedIds = [fixedIds.dataReceived, fixedIds.HMRCStatus]

  return (
    <>
      <PermittedComponent isAccess={checkAccess(module_id, "view")}>
        <CommonTable
          columns={columns}
          data={data}
          heading={
            <div className="d-flex align-items-center gap-3">
              <div>Tasks</div>
              {selectForAction.length ? (
                <div className="d-flex">
                  <select
                    className="form-select form-select me-2"
                    style={{ width: "150px" }}
                    value={selectedStatus}
                    onChange={e => setSelectedStatus(e.target.value)}
                  >
                    <option value="">Select Status</option>
                    {allowed_status_options
                      .filter(s => allowedIds.includes(s.id))
                      .map(status => (
                        <option key={status.id} value={status.id}>
                          {status.statusName}
                        </option>
                      ))}
                  </select>
                  <button
                    onClick={handleUpdateStatus}
                    title="Update Status"
                    className="btn btn-success bg-green"
                  >
                    <i className="fas fa-check me-1"></i> Update
                  </button>
                </div>
              ) : null}
            </div>
          }
          headerHtml={
            <input
              type="checkbox"
              onChange={handleAllCheckUncheck}
              checked={data.length && selectForAction.length === data.length}
            />
          }
        >
          <div>
            {checkAccess(32, "view") && (
              <Link
                to={`${app_url}archived-tasks`}
                className="btn btn-secondary ms-3"
              >
                <i className="fas fa-archive me-2"></i>
                Archived Tasks
              </Link>
            )}

            {checkAccess(module_id, "add") && (
              <Link
                to={`${app_url}add-task`}
                className="btn btn-primary bg-blue ms-3"
              >
                <i className="fas fa-plus me-2"></i>
                Add Task
              </Link>
            )}

            <TimesheetFilter
              data={{
                status_options,
                table_data,
                settable_data,
                all_tasks,
                all_services,
                emp_options,
                taskName_options,
                clientName_options,
                clientCode_options,
                type: "task",
              }}
            />

            <button
              onClick={() => navigate(-1)}
              className="btn btn-secondary bg-dark ms-3"
            >
              <i className="fas fa-arrow-left me-3"></i>
              Back
            </button>
          </div>
        </CommonTable>

        <AddHoursTime
          show={show}
          setShow={setShow}
          setTaskData={settable_data}
          setAllTasks={setAllTasks}
          ids={ids}
        />

        <TimeHistory
          show={showHistory}
          setShow={setShowHistory}
          taskData={taskData}
          setTaskData={setTaskData}
          settable_data={settable_data}
        />
      </PermittedComponent>

      <ClientEmailsModal
        show={showEmailFiles}
        setShow={setShowEmailFiles}
        task={emailFilesClient}
      />
    </>
  )
}

export default AllTasks
